import { render } from "./SkiSettings.vue?vue&type=template&id=0f9ad6fc&scoped=true"
import script from "./SkiSettings.vue?vue&type=script&lang=js"
export * from "./SkiSettings.vue?vue&type=script&lang=js"

import "./SkiSettings.vue?vue&type=style&index=0&id=0f9ad6fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9ad6fc"]])

export default __exports__